import { createApp } from 'vue'
import App from './App.vue'
import PolarisVue from '@ownego/polaris-vue'
import '@ownego/polaris-vue/dist/style.css'
import PrimeVue from 'primevue/config';
import { createPinia } from 'pinia'
const pinia = createPinia()
createApp(App).use(PolarisVue).use(pinia).use(PrimeVue).mount('#app')
